import React from 'react';
import { useField } from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import FileClick from './FileClick.jsx';
import FileDrop from './FileDrop.jsx';
import FieldFileSlide from './FieldFileSlide.jsx';

const FieldFileCoverImgVideo = ({
  api,
  className = '',
  name,
  fileOpts,
}) => {
  const fOpts = { accept: 'image/jpeg, image/png, video/mp4', ...fileOpts };
  const [{ value },, { setValue }] = useField({ name });
  const onFileAdd = async ([f]) => {
    setValue(f);
  };

  return (
    <div
      className={`file-cover-img onhvr ${className}`}
    >
      {value && (
        <div className="ctrls">
          <button
            type="button"
            className="btn btn-link mx-1"
            onClick={() => setValue(null)}
          ><FA icon={faTimes} /></button>
        </div>
      )}
      <FileDrop onDrop={onFileAdd} {...fOpts}>
        <FileClick onFile={onFileAdd} {...fOpts}>
          <FieldFileSlide
            api={{ url: api }}
            name={name}
            className="pos-abs-fill"
          >
            <div
              className="pos-abs-center tra-opacity opacity-8 hvr-opacity-10"
            >
              <span className="btn btn-secondary">
                Drop your image/video or <u>Browse</u>
              </span>
            </div>
          </FieldFileSlide>
        </FileClick>
      </FileDrop>
    </div>
  );
};

export default FieldFileCoverImgVideo;
